// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"96ef7a84","342":"d830d3c6"}[chunkId] + ".css";
};